// src/components/Products/ProductCard.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../../context/CartContext";
import "./ProductCard.css";

export default function ProductCard({ product }) {
  const { addItem, toggleWishlist, wishlist } = useCart();
  const navigate = useNavigate();
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedColorIdx, setSelectedColorIdx] = useState(0);
  const [added, setAdded] = useState(false);
  const [sizeError, setSizeError] = useState(false);

  const isWishlisted = wishlist.some(w => w.id === product.id);
  const discount = Math.round(((product.mrp - product.price) / product.mrp) * 100);
  const memberSave = Math.round((product.mrp - product.price) * 0.1);

  const handleAdd = (e) => {
    e.stopPropagation();
    if (!selectedSize) { setSizeError(true); setTimeout(() => setSizeError(false), 1500); return; }
    addItem({ ...product, selectedSize, selectedColor: product.colors[selectedColorIdx] });
    setAdded(true);
    setTimeout(() => setAdded(false), 1800);
  };

  const handleWishlist = (e) => {
    e.stopPropagation();
    toggleWishlist(product);
  };

  return (
    <div className="product-card" onClick={() => navigate(`/product/${product.id}`)}>
      {/* Image area */}
      <div className="product-card__img-wrap">
        <img src={product.img} alt={product.name} className="product-card__img" loading="lazy" />

        {/* Badge top-left */}
        {product.badge && (
          <span className={`product-card__badge product-card__badge--${product.badge.toLowerCase().replace(/ /g, "-")}`}>
            {product.badge}
          </span>
        )}

        {/* Discount top-right */}
        {discount > 0 && (
          <span className="product-card__discount">{discount}% OFF</span>
        )}

        {/* Wishlist heart */}
        <button className="product-card__wishlist" onClick={handleWishlist} aria-label="Wishlist">
          <svg width="18" height="18" viewBox="0 0 24 24"
            fill={isWishlisted ? "#e84c3d" : "none"}
            stroke={isWishlisted ? "#e84c3d" : "#888"} strokeWidth="2">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
          </svg>
        </button>
      </div>

      {/* Card body */}
      <div className="product-card__body">
        <p className="product-card__brand">{product.brand}</p>
        <p className="product-card__name">{product.name}</p>

        {/* Rating */}
        <div className="product-card__rating">
          {[1,2,3,4,5].map(i => (
            <svg key={i} width="11" height="11" viewBox="0 0 12 12">
              <path d="M6 1l1.4 2.8L10.6 4l-2.3 2.2.5 3.3L6 8l-2.8 1.5.5-3.3L1.4 4l3.2-.2L6 1z"
                fill={i <= Math.round(product.rating) ? "#f5a742" : "#e0e0e0"}/>
            </svg>
          ))}
          <span className="product-card__reviews">({product.reviews.toLocaleString()})</span>
        </div>

        {/* Colors */}
        <div className="product-card__colors">
          {product.colors.map((c, i) => (
            <button key={i} className={`product-card__color ${selectedColorIdx === i ? "product-card__color--active" : ""}`}
              style={{ background: c, border: c === "#fff" ? "1px solid #ddd" : "none" }}
              onClick={e => { e.stopPropagation(); setSelectedColorIdx(i); }}
              aria-label={`Color ${i + 1}`}
            />
          ))}
          <span className="product-card__color-more">+{product.colors.length} colours</span>
        </div>

        {/* Sizes */}
        <div className={`product-card__sizes ${sizeError ? "product-card__sizes--error" : ""}`}>
          {product.sizes.slice(0, 6).map(s => (
            <button key={s}
              className={`product-card__size ${selectedSize === s ? "product-card__size--active" : ""}`}
              onClick={e => { e.stopPropagation(); setSelectedSize(s); }}>{s}</button>
          ))}
          {product.sizes.length > 6 && <span className="product-card__size-more">+{product.sizes.length - 6}</span>}
        </div>
        {sizeError && <p className="product-card__size-err">Please select a size</p>}

        {/* Price */}
        <div className="product-card__price-row">
          <span className="product-card__price">₹ {product.price.toLocaleString()}</span>
          {product.mrp > product.price && <span className="product-card__mrp">₹ {product.mrp.toLocaleString()}</span>}
        </div>
        {memberSave > 0 && (
          <p className="product-card__member-savings">Member Savings ₹ {memberSave}</p>
        )}

        {/* Add to bag */}
        <button className={`product-card__add-btn ${added ? "product-card__add-btn--added" : ""}`}
          onClick={handleAdd}>
          {added ? "✓ ADDED TO BAG" : "ADD TO BAG"}
        </button>
      </div>
    </div>
  );
}
